import { SvgIcon, type SvgIconProps, useTheme } from "@mui/material";

// Active-state Calendar & dispatch glyph — filled counterpart of CalenderTimerIcon.
export const CalenderTimerFilledIcon = (props: SvgIconProps) => {
  const theme = useTheme();
  const fill = theme.palette.neutral.main;

  return (
    <SvgIcon {...props}>
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={fill}
          fillRule="evenodd"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19 10V7a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h4"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M3 9h16M15 3v2M7 3v2"
        />
        <path
          fill={fill}
          fillRule="evenodd"
          stroke="currentColor"
          strokeWidth="1.5"
          d="M17.5 22a4.5 4.5 0 0 1-4.5-4.5c0-2.434 2.07-4.503 4.504-4.5a4.5 4.5 0 0 1-.004 9"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M17.395 15.983v1.758l1.381.843"
        />
      </svg>
    </SvgIcon>
  );
};
